<ng-container *ngIf="isReady$ | async; else loading">
  <rd-core-main-container>
    <bnz-bypass-block bypass-block></bnz-bypass-block>
    <bnz-desktop-header main-header role="header"></bnz-desktop-header>
    <bnz-core-main-footer main-footer></bnz-core-main-footer>
  </rd-core-main-container>
</ng-container>

<ng-template #loading>
  <div class="flex h-screen w-screen items-center justify-center">
    <rd-shared-spinner></rd-shared-spinner>
  </div>
</ng-template>
